import { useState, useCallback } from 'react';

// Single shared browser-geolocation source. Previously the home page (city/
// district auto-detect) and RecommendCard (nearby-vs-hot ranking) each called
// navigator.geolocation.getCurrentPosition independently — a user granting
// permission on one didn't feed the other, and a user who declined the
// home page's automatic request had no way to opt in later short of an OS-
// level permission reset. request() is idempotent to call from multiple
// places (a second call while 'asking'/'ok' is a no-op), so the home page
// can auto-request on mount while RecommendCard's "開啟定位" button re-uses
// the exact same request()/status/gps for anyone who skipped that prompt.
export function useGeolocation() {
  const [gps, setGps] = useState(null);
  const [status, setStatus] = useState('idle'); // idle | asking | ok | denied | unsupported

  const request = useCallback(() => {
    setStatus((prev) => {
      if (prev === 'asking' || prev === 'ok') return prev; // already in flight or done
      if (!navigator.geolocation) return 'unsupported';
      navigator.geolocation.getCurrentPosition(
        (pos) => { setGps({ lat: pos.coords.latitude, lng: pos.coords.longitude }); setStatus('ok'); },
        () => setStatus('denied'),
        { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 }
      );
      return 'asking';
    });
  }, []);

  return { gps, status, request };
}
